// Depending on the type of shipping method, Eagle will return the value with a hyphen, e.g. `next-day`
// Prismic however seems to expect it as `nextday` and is expecting tracked to be express.
// To handle this, we replace the hyphen with an empty string
export default type => type === 'tracked' ? 'express' : type.replace('-', '');



// WEBPACK FOOTER //
// ./src/common/utils/shipping-type-to-prismic-key.js